import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ad9a7af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-analysis-dashboard" }
const _hoisted_2 = { class: "home-analysis-dashboard-top" }
const _hoisted_3 = { class: "home-analysis-dashboard-top home-analysis-dashboard-top-second" }
const _hoisted_4 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "今日回款", -1))
const _hoisted_6 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "电催回款", -1))
const _hoisted_8 = { class: "home-analysis-dashboard-top-second-item-item-data" }
const _hoisted_9 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "上门回款", -1))
const _hoisted_11 = { class: "home-analysis-dashboard-top-second-item-item-data" }
const _hoisted_12 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "赎回回款", -1))
const _hoisted_14 = { class: "home-analysis-dashboard-top-second-item-item-data" }
const _hoisted_15 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "逾期总台数", -1))
const _hoisted_17 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "已收车", -1))
const _hoisted_19 = { class: "home-analysis-dashboard-top-second-item-item-data" }
const _hoisted_20 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "已赎回", -1))
const _hoisted_22 = { class: "home-analysis-dashboard-top-second-item-item-data" }
const _hoisted_23 = { class: "home-analysis-dashboard-top-second-item-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-analysis-dashboard-top-second-item-item-name local-main-color-secondary-text" }, "已处置", -1))
const _hoisted_25 = { class: "home-analysis-dashboard-top-second-item-item-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeAnalysisDashboardItem = _resolveComponent("HomeAnalysisDashboardItem")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_NumberChange = _resolveComponent("NumberChange")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HomeAnalysisDashboardItem, {
        name: 'M0',
        num: _ctx.top.data.M0,
        rate: _ctx.top.data.M0Rate,
        rgb: '140, 84, 255'
      }, null, 8, ["num", "rate"]),
      _createVNode(_component_HomeAnalysisDashboardItem, {
        name: 'M1',
        num: _ctx.top.data.M1,
        rate: _ctx.top.data.M1Rate,
        rgb: '0, 193, 212'
      }, null, 8, ["num", "rate"]),
      _createVNode(_component_HomeAnalysisDashboardItem, {
        name: 'M2',
        num: _ctx.top.data.M2,
        rate: _ctx.top.data.M2Rate,
        rgb: '51, 172, 46'
      }, null, 8, ["num", "rate"]),
      _createVNode(_component_HomeAnalysisDashboardItem, {
        name: 'M3+',
        num: _ctx.top.data['M3+'],
        rate: _ctx.top.data['M3+Rate'],
        rgb: '255, 72, 89'
      }, null, 8, ["num", "rate"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "home-analysis-dashboard-top-second-item home-view-box",
        style: _normalizeStyle({ background: 'linear-gradient( 90deg, #E0EAFE 0%, rgba(224,234,254,0) 100%), #F5F7FA' })
      }, [
        _createVNode(_component_HomeIcon, {
          name: 'price',
          rgb: '33, 126, 255'
        }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "home-analysis-dashboard-top-second-item-item-data",
            style: _normalizeStyle({ color: 'rgba(33, 126, 255,1)' })
          }, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.todayPaymentCollection,
              decimal: 2
            }, null, 8, ["data"])
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.paymentCollection1,
              decimal: 2
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.paymentCollection2,
              decimal: 2
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.paymentCollectionRedemption,
              decimal: 2
            }, null, 8, ["data"])
          ])
        ])
      ], 4),
      _createElementVNode("div", {
        class: "home-analysis-dashboard-top-second-item home-view-box",
        style: _normalizeStyle({ background: 'linear-gradient( 90deg, #FFF0F0 0%, rgba(255,240,240,0.01) 100%), #F5F7FA' })
      }, [
        _createVNode(_component_HomeIcon, {
          name: 'wave',
          rgb: '255, 0, 0'
        }),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", {
            class: "home-analysis-dashboard-top-second-item-item-data",
            style: _normalizeStyle({ color: 'rgba(255, 0, 0,1)' })
          }, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.overVehicleCount
            }, null, 8, ["data"])
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.keepCount
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.handleCount
            }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_NumberChange, {
              data: _ctx.second.redemptionCount
            }, null, 8, ["data"])
          ])
        ])
      ], 4)
    ])
  ]))
}